import {RefundState} from 'web-angular-client';

const REFUND_STATUS_LABELS: Record<string, string> = {
    INITIATED: 'Initiated',
    OPEN: 'Awaiting customer',
    PENDING: 'Pending',
    SUCCESS: 'Completed',
    EXPIRED: 'Expired',
    CANCELLED_BY_MERCHANT: 'Cancelled (merchant)',
    CANCELLED_BY_CUSTOMER: 'Cancelled (customer)',
    FAILED: 'Failed'
};

const REFUND_STATUS_CLASSES: Record<string, string> = {
    INITIATED: 'in-progress-payment-color',
    OPEN: 'in-progress-payment-color',
    PENDING: 'in-progress-payment-color',
    SUCCESS: 'settled-payment-color',
    EXPIRED: 'expired-or-cancelled-payment-color',
    CANCELLED_BY_MERCHANT: 'expired-or-cancelled-payment-color',
    CANCELLED_BY_CUSTOMER: 'expired-or-cancelled-payment-color',
    FAILED: 'expired-or-cancelled-payment-color'
};

/**
 * Resolves the merchant-facing display label for a refund state.
 *
 * @param state the refund state
 * @return a human-readable label for the state, or 'Unknown' when not recognised
 */
export function getRefundStatusLabel(state: RefundState | null | undefined): string
{
    return (state && REFUND_STATUS_LABELS[state]) || 'Unknown';
}

/**
 * Resolves the text-colour CSS class for a refund state, using the same palette as the ecommerce transactions list.
 *
 * @param state the refund state
 * @return the text-colour class for the state, or the neutral default colour when not recognised
 */
export function getRefundStatusClass(state: RefundState | null | undefined): string
{
    return (state && REFUND_STATUS_CLASSES[state]) || 'default-payment-color';
}
